import * as React from "react"
import { formatDate } from "@ui-seeker/utils"
import { Table, TableBody, TableContainer, TableHead, TableRow, TableCell, capitalize } from "@mui/material";

export default function TitleTooltip ({keys, allData}) {
    return <TableContainer sx={{ maxHeight: 200, background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)' }}>
        <Table sx={{ width: '225px' }}>
            <TableHead>
                <TableRow sx={{ position: 'sticky', top: 0, background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)' }}>
                    {keys.map((key, idx) => <TableCell key={idx} sx={{color: 'primary.darker', fontWeight: 'bold', textAlign: 'center', borderBottomColor: 'grey.500'}} >
                            {capitalize(key)}
                        </TableCell>
                    )}
                </TableRow>
            </TableHead>

            <TableBody>
                { allData.map((dataRow, idx) => <TableRow key={idx}>
                    {keys.map((key) => <TableCell sx={{color: 'primary.darker', textAlign: 'center', borderBottomColor: 'grey.500'}}>
                            {key === 'date' ? formatDate(dataRow[key], { isString: true, format: 'yyyy/mm/dd', receivedFormat: 'yyyymmdd' }) : dataRow[key]}
                        </TableCell>
                    )}
                </TableRow>) }
            </TableBody>
        </Table>
    </TableContainer>
}